// Routes for known projects, keyed by projectName as returned by the API.
// For any project not listed here a slug-based route is derived automatically.

/**
 * Routes that are shared across all projects (e.g. User Management, auth pages).
 * These are accessible regardless of which project(s) the user belongs to.
 */
const SHARED_PATH_PREFIXES = [
  "/UserManagement",
  "/login",
  "/forgotPassword",
  "/createpassword",
  "/signup",
];

/**
 * Returns the project name that owns a given pathname, or null for shared routes.
 * LIT routes all start with "/lit/"; shared routes return null; everything else belongs to STB.
 * Extend this map as new projects are added to PROJECT_ROUTE_MAP.
 */
export const getProjectForPath = (pathname) => {
  if (SHARED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return null;
  if (pathname.startsWith("/lit/")) return "LIT";
  return "STB";
};

export const PROJECT_ROUTE_MAP = {
  STB: "/dashboards/home",
  LIT: "/lit/dashboard/home",
  // "CDN Manager": "/cdn-manager/dashboard/home",
};

export const isValidProject = (projectName) =>
  Boolean(PROJECT_ROUTE_MAP[projectName]);

const deriveRoute = (projectName) => {
  if (PROJECT_ROUTE_MAP[projectName]) return PROJECT_ROUTE_MAP[projectName];
  const slug = projectName.toLowerCase().replace(/\s+/g, "-");
  return `/${slug}/dashboard/home`;
};

// Transforms the /user-project API response ({ sid, projectName }[]) into the option shape consumed by WorkspaceSwitcher and Login.
export const buildWorkspaceOptions = (userProjects = []) => {
  if (!userProjects.length) return [];

  return userProjects
    .filter((p) => p.projectName)
    .map((p) => ({
      value: p.projectName,
      label: p.projectName,
      route: deriveRoute(p.projectName),
      projectId: p.sid,
    }));
};
